import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/ray-manista.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'Raymond J. Manista';
  const nameString = 'ray-manista';
  const title = 'Chief Legal & Public Affairs Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-legal-and-public-affairs-officer'
      header={name}
      title={title}
      isExecutiveVicePresident
      content={(
        <>
          <Typography
            itemprop='description'
            nextElement='link'>
            Raymond oversees the company&#39;s Law and Public Affairs activities, including law, enterprise compliance, strategic communications, privacy, enterprise sustainability, government relations, and strategic philanthropy and community relations &#40;Northwestern Mutual Foundation&#41;. He also serves as the Corporate Secretary to the company&#39;s Board of Trustees.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/manista-raymond-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/ray-manista/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual Executive Vice President and ${title} ${name}.`}
      reversed={false}
    />
  );
};
